import React, { useEffect, useState } from 'react';
import Config from '../../config/Config';
import Loader from '../../utils/Loader';
import $ from 'jquery';
import { conditionallyClearStorage } from '../../utils/commonFunctions';
import Auth from '../../utils/Auth';

const PaymentFailure = () => {
	const [continueText, setContinueText] = useState('');
	const [infoText, setInfoText] = useState('');
	const currentProductId = localStorage.getItem('currentProductId');
	const productNav = localStorage.getItem('productNav');

	useEffect(() => {
		document.getElementById('chat-circle').style.display = 'none';
		if (localStorage.getItem('referer') === 'landing') {
			localStorage.removeItem('token');
		}

		$('.download-app').hide();
		$('.body-container').css('background', '#e5f3fa');

		return () => {
			document.getElementById('chat-circle').style.display = 'block';
		};
	}, [continueText]);

	useEffect(() => {
		Loader.hide();
		if (localStorage.getItem('sso') === '0') {
			let isNewUser =
				localStorage.getItem('new_user').toLowerCase() === 'true' ? true : false;
			Auth.isAuthenticated = null;
			localStorage.setItem('return_path', 'purchase');

			setContinueText(
				`Click on CONTINUE to buy <b>${localStorage.getItem(
					'gtm_prod_name',
				)}</b> at ${
					localStorage.getItem('payment_type')?.toLowerCase() === 'stripe'
						? '$'
						: 'Rs.'
				} <i>${localStorage.getItem(
					'gtm_prod_final',
				)}</i>. Or, click on GO BACK to return to the product page.`,
			);
			setInfoText(
				isNewUser
					? `Your login PIN has been sent to ${localStorage.getItem('login_id')}`
					: '',
			);
		} else {
			setContinueText(
				`Click on CONTINUE to buy <b>${localStorage.getItem(
					'gtm_prod_name',
				)}</b> at ${
					localStorage.getItem('payment_type')?.toLowerCase() === 'stripe'
						? '$'
						: 'Rs.'
				} <i>${localStorage.getItem('gtm_prod_final')}</i>.`,
			);
		}
	}, [continueText]);

	useEffect(() => {
		return () => {
			if (localStorage.getItem('sso') === '0') {
				conditionallyClearStorage([
					'login_id',
					'loginId',
					'return_path',
					'currentProductId',
					'productNav',
					'gtm_prod_name',
					'active_course_id',
					'gtm_prod_final',
				]);
			}
		};
	}, []);

	return (
		<div>
			<div className="container nopadding-mobile">
				<div className="row">
					<div
						className="col-lg-12 col-lg-offset-2 text-center"
						style={{ 'margin-top': '50px' }}
					>
						<img
							className="paymentStatusIcon"
							src={`${Config.ASSETSPATH}img/error.png`}
							alt="error"
						/>
						<div className="col-lg-12 text-center" style={{ 'margin-top': '10px' }}>
							<p className="payment-failure-text">Your payment was unsuccessful.</p>

							<div
								className="payment-continue-text"
								dangerouslySetInnerHTML={{ __html: continueText }}
							/>

							<a href={`/purchase?productID=${currentProductId}`}>
								<button aria-label="continue" className="btn btn-danger mr20">
									Continue
								</button>
							</a>
							<a href={`${Config.WEBSITEURL}product/${productNav}`}>
								<button aria-label="go-back" className=" btn goBack">
									GO BACK
								</button>
							</a>

							<p className="payment-instruction-text">{infoText}</p>

							<div>
								<img
									src={Config.ASSETSPATH + 'img/payment_logo.png'}
									className="mt-5"
									alt="Logo"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PaymentFailure;
